module.exports = __webpack_public_path__ + "media/dashboard/assets/images/phone-forward-ab409e6218c4988a2891f685844280a8.svg";